export const SlideBreakpts = () => ({
    380: {
      perPage: 1,
    },
    768: {
      perPage: 2,
    },
    100: {
      perPage: 2,
    },
    1200: {
      perPage: 3,
    },
  });